import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.markdownRemark
  const siteTitle = data.site.siteMetadata.title
  const { previous, next } = pageContext

  return (
    <Layout location={location} title={siteTitle}>
      <SEO
        title={post.frontmatter.title}
        description={post.excerpt}
      />
      <div class='pageContent'>
        <article class="postPage article">
          <header class="postPage__header">
            <h1 class="postPage__title">{post.frontmatter.title}</h1>
            <p class="postPage__date"><time datetime={post.frontmatter.date}>{post.frontmatter.date}</time></p>
            {post.frontmatter.tags != null &&post.frontmatter.tags.length > 0 &&
              <ul id="tags" >
                {post.frontmatter.tags.map((tag) => 
                <li class="tag">
                  <span class={'tag-' +tag}>{tag}</span>
                </li>
                )}
              </ul>
            }
          </header>
          <section class="postPage__content" dangerouslySetInnerHTML={{ __html: post.html }} />
          <div id="author">
            <p class="intro">This blog post was written by</p>
            <div>
              <img src={'/images/me.jpg'} />
              <h4><a href="http://invently.co.uk">Craig Pickles</a></h4>
              <p>Software developer, team leader and technologist.</p>
            </div>
          </div>
        </article>
      </div>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 320)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        tags
      }
    }
  }
`
